import LocalForage from 'localforage';
import { maker } from 'utils';
import * as sessionStorageDriver from 'localforage-driver-session-storage';
class Storage {
  dbPromise;
  constructor (storeName = 'member') {
    this.dbPromise = new Promise((resolve, reject) => {
      let db;
      let config = {
          name: 'lidachat',
          storeName: storeName,
          driverOrder: [sessionStorageDriver._driver]
      }
      LocalForage.defineDriver(sessionStorageDriver).then(() => {
        db = LocalForage.createInstance(config);
      })
        .then(() => db.setDriver(config.driverOrder))
        .then(() => {
          resolve(db);
        })
        .catch(reason => reject(reason));
    });
  }
  ready () {
    return this.dbPromise;
  }
  getDriverOrder (driverOrder) {
    return driverOrder.map((driver) => {
        switch (driver) {
          case 'sqlite':
            return CordovaSQLiteDriver._driver;
          case 'indexeddb':
            return LocalForage.INDEXEDDB;
          case 'websql':
            return LocalForage.WEBSQL;
          case 'localstorage':
            return LocalForage.LOCALSTORAGE;
        }
    });
  }
  getItem (key) {
    return this.dbPromise.then(db => db.getItem(key).then(result => maker.oppsmd(result)))
    // return this.dbPromise.then(db => db.getItem(key));
  }
  getItems () {
    return this.dbPromise.then(db => {
      return db.keys().then((key) => 
       key.reduce(async(obj, res) => {
          let accumulation = await obj
          // accumulation[res] = await db.getItem(res)
          accumulation[res] = await db.getItem(res).then(result => maker.oppsmd(result))
          return accumulation
        }, Promise.resolve({}))
      )
    });
  }
  setItem (key, value) {
    const values = new maker(value).psmd()
    return this.dbPromise.then(db => db.setItem(key, values));
  }
  removeItem (key) {
    return this.dbPromise.then(db => db.removeItem(key));
  }
  clear () {
    return this.dbPromise.then(db => db.clear());
  }
  keys () {
    return this.dbPromise.then(db => db.keys())
  }
  iterate (callback) {
    return this.dbPromise.then(db => db.iterate(callback))
  }
}
export default Storage